import { alarmStatusColorState } from '../state/alarmStatusColorState';
import { Fetch_All_Region_Data1,GET_STATUS_COLOR_REQUEST, GET_STATUS_COLOR_SUCCESS, UPDATE_STATUS_COLOR_SUCCESS} from '../action/alarmStatusColorAction';

export function AlarmStatusColorReducer(state = alarmStatusColorState, action) {
    switch(action.type){
        case GET_STATUS_COLOR_REQUEST:
            return Object.assign({}, state, {
                errorCode : 0,
                statusCode : 0,
                message : '',
                isLoading : action.isLoading
            })
        case GET_STATUS_COLOR_SUCCESS:
            return Object.assign({},state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                alarmStatusColorList : action.list,
                isLoading : action.isLoading
            })
        case UPDATE_STATUS_COLOR_SUCCESS:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                alarmStatusColorList : action.list,
                isLoading : action.isLoading,
                message : action.message
            })
            case Fetch_All_Region_Data1:
                                                                    return Object.assign({}, state, {
                                                                        errorCode : action.errorCode,
                                                                        statusCode : action.statusCode,
                                                                        regionList : action.regionList
                                                                    })
        default:
            return state
    }
}